import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { BondSection } from './components/BondSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-brand-cream font-body selection:bg-brand-teal selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <HookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedAttemptsSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGetSection data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <ProofSection data-id="element-9" />
      <BondSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <OfferSection data-id="element-12" />
      <Footer data-id="element-13" />
    </main>;
}